import * as React from 'react';
import { BaseTableList } from 'components/AgGrid/AgGrid';
import { ListWrapper } from 'components/AgGrid/CellRenderer/ListView.styled';
import { StageProgressBarRenderer, formatDate } from '../Helper/helperFunction';
import useTimeDisplayMode from 'hooks/useTimeDisplayMode';
import { useTranslation } from 'react-i18next';

interface Props {
  workOrders: any[];
}

export const WorkOrdersHistory: React.FC<Props> = ({ workOrders }) => {
  const { t } = useTranslation();
  const { preferredTimeDisplayMode, timezone } = useTimeDisplayMode();
  const rowData = React.useMemo(() => workOrders, [workOrders]);

  const columnDefs = React.useMemo(
    () => [
      {
        field: 'workorder_name',
        headerName: t('file_name'),
        filter: 'agTextColumnFilter',
        sortable: true,
      },
      {
        field: 'created_ts',
        headerName: t('created_timestamp'),
        filter: 'agNumberColumnFilter',
        sort: 'desc' as const,
        sortable: true,
        cellRendererFramework: (params: any) =>
          formatDate({
            value: params.value,
            preferredTimeDisplayMode,
            timezone,
          }),
      },
      {
        field: 'completed_ts',
        headerName: t('completed_timestamp'),
        filter: 'agNumberColumnFilter',
        sortable: true,
        cellRendererFramework: (params: any) =>
          formatDate({
            value: params.value,
            preferredTimeDisplayMode,
            timezone,
          }),
      },
      {
        field: 'stage',
        headerName: t('stage'),
        filter: 'agTextColumnFilter',
        sortable: true,
        cellRendererFramework: StageProgressBarRenderer,
      },
    ],
    [preferredTimeDisplayMode, timezone]
  );

  const filterFunction = (node: any) => {
    return !!node.data?.isActive;
  };

  return (
    <ListWrapper>
      <BaseTableList
        rowData={rowData}
        columnDefs={columnDefs}
        filter={filterFunction}
        pagination={true}
        paginationPageSize={20}
      />
    </ListWrapper>
  );
};
